import { legacyAppUrl } from "../lib/legacyApp";
import { useSignups } from "../lib/useSignups";

/**
 * THE "REQUEST ACCESS" CTA, IN ONE PLACE.
 *
 * WHAT WAS WRONG (owner, 2026-08-10): "I clicked request access myself and it took me to the
 * current apex build, soon to be old, and we know that is clunky and unstable."
 *
 * He is right, and the round trip was worse than clunky — it was pointless. Sign-ups are closed, so
 * the only thing waiting at the end of that navigation is a sentence saying so. Three CTAs on this
 * landing page sent a visitor into an app we are deprecating to be told no.
 *
 * WHAT IT DOES NOW, AND WHY THAT IS THE SAME WORKFLOW AND NOT A NEW ONE. On the apex today, with
 * sign-ups closed, `requestAccess()` calls `showAuth('login')` — "Request access" and "Sign in"
 * already do the identical thing there, both opening the auth modal on the Log in tab. So sending
 * this CTA to `/next`'s own `/login` is not a simplification of the current behaviour; it IS the
 * current behaviour, expressed with the tools this client already has instead of a modal system it
 * does not.
 *
 * THE LABEL NEVER CHANGES, ONLY THE DESTINATION, which is what makes the `unknown` first paint
 * harmless: there is no window in which a visitor reads the wrong words. `useSignups` resolves an
 * unreachable endpoint to "closed", so the pre-answer destination and the failure destination are
 * both `/login` — the one that cannot dead-end.
 *
 * WHEN SIGN-UPS OPEN it goes back to the apex, because that is still where account creation lives
 * (`marketing/sections.tsx` has said so since this client shipped) and `/next` has no signup screen
 * yet. That is a real gap and it is deliberately visible here rather than papered over: the day a
 * `/signup` route exists in this client, this is the one line that changes.
 */
export function RequestAccessLink({ className = "btn" }: { className?: string }) {
  const { status } = useSignups();
  // `legacyAppUrl()` and not a literal: after the apex swap the legacy app is old.valubrief.ai, and
  // a hardcoded https://valubrief.ai/ here would point this button at the page it is printed on.
  const href = status === "open" ? legacyAppUrl() : "/login";
  return (
    <a className={className} href={href}>
      Request access
    </a>
  );
}
